import styled from 'styled-components'
import PropTypes from 'prop-types'
import Message from 'common/message'
import Picture from './picture'

const BigImageStyled = styled.div`
  margin: 32px 0;
  span {
    display: block;
    font-size: 14px;
    line-height: 24px;
    color: var(--textOpaque);
    text-align: center;
    margin-top: 16px;
  }
  .image {
    max-width: 100%;
    width: auto;
    margin: 0 auto;
    display: block;
  }
  .image-grid {
    display: grid;
    &-item {
      width: auto;
      height: auto;
      max-width: 100%;
      margin: 0;
    }
  }
  .two-images-grid {
    column-gap: 24px;
    row-gap: 24px;
    grid-template-columns: 1fr;
  }
  .six-images-grid {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    column-gap: 8px;
    row-gap: 8px;
  }
  @media(min-width: 768px) {
    margin: 48px 0;
    .two-images-grid {
      grid-template-columns: 1fr 1fr;
    }
    .six-images-grid {
      column-gap: 24px;
      row-gap: 24px;
    }
  }
  /* We use 808 because we have a wrapper of 680px and a minimun padding of 64px on the sides */
  @media(min-width: 808px) {
    /* calc(calc(100vw - 808) / 2) */
    margin-right: calc(calc(calc(100vw - 808px) / 2) * -1);
    margin-left: calc(calc(calc(100vw - 808px) / 2) * -1);
  }
  @media(min-width: 1368px) {
    margin-right: -260px;
    margin-left: -260px;
  }
`

function BigImage({ src, alt, images, description }) {
  if (alt === 'null') return null

  if (alt.includes('size-fit')) {
    return (
      <Picture src={src} alt={alt.slice(0, -9)} />
    )
  }

  if (src) {
    return (
      <BigImageStyled>
        <img className="image" src={src} alt={alt} loading="lazy" />
        {alt && alt !== 'alt' && <span>{alt}</span>}
      </BigImageStyled>
    )
  }

  if (images && images.length === 2) {
    return (
      <BigImageStyled>
        <div className="image-grid two-images-grid">
          {images.map(({ src: url, alt: helpText }) => (
            <img className="image-grid-item" src={url} alt={helpText} loading="lazy" width="588px" height="400px" />
          ))}
        </div>
        <span>{description}</span>
      </BigImageStyled>
    )
  }

  if (images && images.length === 6) {
    return (
      <BigImageStyled>
        <div className="image-grid six-images-grid">
          {images.map(({ src: url, alt: helpText }) => (
            <img className="image-grid-item" src={url} alt={helpText} loading="lazy" width="384px" height="250px" />
          ))}
        </div>
        <span>{description}</span>
      </BigImageStyled>
    )
  }

  return (
    <Message
      color="var(--error)!important"
      fontSize="54px!important"
      lineHeight="60px!important"
      error
    >
      Le falta un atributo a tu imagen o tu array de imagenes es incorrecto.
    </Message>
  )
}

BigImage.defaultProps = {
  src: '',
  alt: '',
  images: null,
}

BigImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  images: PropTypes.arrayOf({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
}

export default BigImage
